var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 4 }
            },
            [
              _c("el-step", { attrs: { title: "海运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "增值服务" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "托运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "确认委托" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "委托完成" } })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "count_center" }, [
      _c("div", { staticClass: "centerCoutn" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              "text-align": "center",
              "margin-top": "82px"
            }
          },
          [
            _c("i", {
              staticClass:
                "el-icon-success animate__animated animate__bounceInDown",
              staticStyle: { "font-size": "55px", color: "#00c300" }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "20px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#333333",
                  "margin-top": "27px"
                }
              },
              [_vm._v("\n          委托完成\n        ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "14px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#999999",
                  "margin-top": "8px"
                }
              },
              [_vm._v("\n          等待货物入仓\n        ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "countText" }, [
              _c("p", [_vm._v("运单号：" + _vm._s(_vm.innos))]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n            收货人："),
                _c("span", [_vm._v(_vm._s(_vm.sendFeeForAir.name))]),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.sendFeeForAir.tel))
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            收货地址：" +
                    _vm._s(_vm.sendFeeForAir.country) +
                    _vm._s(_vm.sendFeeForAir.city) +
                    _vm._s(_vm.sendFeeForAir.address) +
                    "\n          "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btnWrap",
            staticStyle: { width: "100%", "margin-top": "44px" }
          },
          [
            _c(
              "div",
              { staticClass: "LR_center", staticStyle: { width: "328px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn1",
                    on: {
                      click: function($event) {
                        return _vm.pathBilltab()
                      }
                    }
                  },
                  [_vm._v("查看订单")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn2",
                    on: {
                      click: function($event) {
                        return _vm.nextSetbill()
                      }
                    }
                  },
                  [_vm._v("继续下单")]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4571578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4571578","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/AirOrderSuccess.vue
// module id = null
// module chunks = 